// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { productPriceAndActionsStyle } from "@steiner/App/Components/Product/ProductPriceAndActions";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { css } from "styled-components";

const sharedPriceStyle: TypographyPresentationProps = {
    size: 16,
    lineHeight: "22px",
    weight: fontConfig.weight.semiBold,
    color: "primary",
};
productPriceAndActionsStyle.productListGridContainer = {
    addToCartActions: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
        `,
    },
};
productPriceAndActionsStyle.priceAndQtyContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        gap: 8px;

        &:empty {
            display: none;
        }
    `,
};

productPriceAndActionsStyle.productFields = {
    css: css`
        display: flex;
        gap: 8px;
        align-items: center;
        height: 26px;
        position: relative;
        &:empty,
        & > div:empty {
            display: none;
        }
        & > span[data-state="closed"],
        & > span[data-state="open"] {
            height: 16px;
        }
    `,
};

productPriceAndActionsStyle.addToCartActions = {
    css: css`
        display: flex;
        flex: 1;
        gap: 8px;
        align-items: center;
    `,
};

productPriceAndActionsStyle.addToCartButton = {
    sizeVariant: "small",
    css: css`
        flex: 1;
    `,
};

productPriceAndActionsStyle.qtyDetailsTooltip = {
    mergeCss: true,
    typographyProps: {
        css: css`
            font-size: 12px;
            line-height: 16px;
        `,
    },
    cssOverrides: {
        tooltipClickable: css`
            margin: 0;
        `,
    },
};

productPriceAndActionsStyle.qtyDetailsTooltipList = {
    mergeCss: true,
    typographyProps: {
        css: css`
            font-size: 12px;
            line-height: 16px;
        `,
    },
    cssOverrides: {
        tooltipWrapper: css`
            position: absolute;
            left: -27px;
        `,
    },
};

productPriceAndActionsStyle.qtyDetailsTooltipIcon = {
    size: 16,
    color: "common.ui8",
};
productPriceAndActionsStyle.priceAndAvailabilityContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};
productPriceAndActionsStyle.productPriceStyles = {
    price: {
        priceText: {
            ...sharedPriceStyle,
            css: css`
                margin-right: 4px;
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                ...sharedPriceStyle,
            },
        },
    },

    uomPrice: {
        priceText: {
            ...sharedPriceStyle,
        },
    },
};
